import { Identifiable, Project, WeatherReports } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateProjectWeatherReport(httpClient: HttpClient) {
  return (project: Identifiable<Project>, weatherReport: WeatherReports) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projects/${project.uuid}`,
      method: HttpMethods.PATCH,
      data: { attributes: { ...project.attributes, weather: weatherReport } },
    });
}

export { updateProjectWeatherReport };
